// tslint:disable:promise-function-async (autogenerated)
// tslint:disable:no-unsafe-any (autogenerated)
// tslint:disable:no-any (autogenerated)
import 'isomorphic-fetch';
import * as qs from 'querystring';

// tslint:disable-next-line:typedef (autogenerated)
function serializeData(data): string {
    if (typeof data !== 'string') {
        try {
            // tslint:disable-next-line:no-parameter-reassignment (autogenerated)
            data = JSON.stringify(data);
        } catch (error) {
            throw error;
        }
    }
    return data;
}

interface IRequestOptions {
    url: string;
    data?: any;
    body?: string;
    type?: string;
    contentType?: string;
    xhrFields?: {
        withCredentials?: boolean;
    };
    headers?: {
        Authorization?: string;
    };
}

export type TBodyParseFormat =
    | 'json'
    | 'text'
    | 'form-data'
    | 'blob'
    | 'array-buffer'
    | 'blob-with-filename';

// tslint:disable-next-line:typedef (autogenerated)
export function request(
    requestOptions: IRequestOptions,
    options?: { doNotCheckSuccess?: boolean },
    bodyParseFormat: TBodyParseFormat = 'json'
): Promise<any> {
    if (!requestOptions.url) {
        throw new Error('Url to request not found!');
    }
    requestOptions.type = requestOptions.type || 'POST';

    if (requestOptions.type === 'POST' || requestOptions.type === 'PUT') {
        requestOptions.contentType =
            requestOptions.contentType || 'application/json; charset=utf-8';

        requestOptions.body =
            requestOptions.contentType.indexOf('application/json') >= 0
                ? serializeData(requestOptions.data || {})
                : requestOptions.data;
    }
    const doNotCheckSuccess = options && options.doNotCheckSuccess;

    if (!requestOptions.contentType) {
        // tslint:disable-next-line:no-string-literal (autogenerated)
        delete requestOptions['contentType'];
    }
    return new Promise<any>((resolve, reject) => {
        let params: RequestInit = {
            credentials:
                requestOptions.xhrFields && requestOptions.xhrFields.withCredentials
                    ? 'include'
                    : 'same-origin'
        };

        let query = '';

        if (requestOptions.type === 'POST' || requestOptions.type === 'PUT') {
            params = {
                ...params,
                body: requestOptions.body
            };

            if (requestOptions.contentType) {
                params.headers = {
                    'content-type': requestOptions.contentType
                };
            }
        } else if (requestOptions.data) {
            query = '?' + qs.stringify(requestOptions.data);
        }

        params.method = requestOptions.type;
        params.headers = { ...requestOptions.headers, ...params.headers };

        fetch(requestOptions.url + query, params)
            .then(async (res: Response) => {
                if (!res.ok) {
                    if (res.headers.get('content-type').indexOf('application/json') !== -1) {
                        const json = await res.json();
                        return Promise.reject(json);
                    }
                    return Promise.reject(res.statusText);
                }

                switch (bodyParseFormat) {
                    case 'text': {
                        return res.text();
                    }
                    case 'form-data': {
                        return res.formData();
                    }
                    case 'blob-with-filename': {
                        const blob = await res.blob();
                        const regex = /filename=(.+)$/;
                        const contentDispositionHeader = res.headers.get('content-disposition');
                        if (!contentDispositionHeader) {
                            return {
                                blob
                            };
                        }
                        const match = contentDispositionHeader.match(regex);
                        const filename = match && match[1];
                        if (filename) {
                            return {
                                blob,
                                filename: decodeURIComponent(filename)
                            };
                        }

                        return {
                            blob
                        };
                    }
                    case 'blob': {
                        return res.blob();
                    }
                    case 'array-buffer': {
                        return res.arrayBuffer();
                    }
                    case 'json':
                    default: {
                        return res.json();
                    }
                }
            })
            .then(res => {
                if (doNotCheckSuccess || res.message === 'OK' || res.success) {
                    resolve(res);
                } else {
                    reject(res);
                }
            })
            .catch(err => {
                reject(err);
            });
    });
}
